export const getUniqueId = () => (Math.random() * new Date().getTime()).toString(16).replace('.', '');